import React, { Component, useEffect, useState, useRef } from "react";
import Form from "../../comman/form";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import auth from "../../services/authService";
import Swal from "sweetalert2";
import UploadDocument from "../../comman/UploadDocument";
import UploadRepository from "../../app/components/Document/UploadRepository";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import {
  ddrmsRepoDocumentUploaded,
  getDdrmsRepositoryDocuments,
  getDdrmsRepoUploadStatus,
  loadDdrmsRepositoryDocs,
  UploadDdrmsRepositoryDocs,
} from "../../app/store/ddrmsDocument";
import {
  getLocalDocUploadSasUrl,
  getLocalDocUploadStatus,
  getUploadDocumentId,
  localDocumentUploaded,
  uploadDocument,
  uploadLocalDocument,
} from "../../app/store/documents";
import UploadLocal from "../../app/components/Document/UploadLocal";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../app/store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../app/store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../app/store/candidate";

const CandidateReqDoc = (props) => {
  const {
    docShowHide,
    handleDocShowHide,
    sendType,
    workItem,
    uploadType,
    applicantObj,
    viewType,
    uploadDocType,
    prevItem
  } = props;

  const [submitProcess, setSubmitProcess] = useState(false);
  const [useType, setUseType] = useState("sharing");
  const [isPwd, setIsPwd] = useState("");
  const [message, setMessage] = useState("");
  const [selectedRepoDocs, setSelectedRepoDocs] = useState([]);
  const [localDocs, setLocalDocs] = useState([]);
  const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
  const [wfTask, setWfTask] = useState(null);
  const [repoDocs, setRepoDocs] = useState([]);
  const [repoLoading, setRepoLoading] = useState(sendType === "repository");
  const repositoryLoadStartedRef = useRef(false);

  const ddrmsRepoUploadStatus = useSelector(getDdrmsRepoUploadStatus);
  const localDocUploadStatusSelector = useSelector(getLocalDocUploadStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);


  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    setMessage("");
    setLocalDocs([]);
    setSelectedRepoDocs([]);
    setIsPwd("");
    setUseType("");
  }, [docShowHide]);

  useEffect(() => {
    setRepoDocs(ddrmsRepositoryDocumentsSelector);
    if (repositoryLoadStartedRef.current) {
      setRepoLoading(false);
      repositoryLoadStartedRef.current = false;
    }
  }, [ddrmsRepositoryDocumentsSelector]);

  useEffect(() => {
    if (workItem?.ciid > 0) {
      if (sendType === "repository") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(workItem.ciid));
      }
      setWfTask(workItem);
    }
    else if (applicantObj?.id) {
      if (prevItem?.applications?.length > 0 && sendType === "repository") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(prevItem.applications[0].ciid));
      }

      if (uploadType === "Subcontractor") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.subcontractor?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Recruiter") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.recruiter?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadRecruiterWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Candidate") {
        dispatch(loadCandidateWfTask(applicantObj?.id));
        setWfTaskReqCount(wfTaskReqCount + 1);
      }
    }
  }, [])

  useEffect(() => {
    if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
      setWfTask(subsCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    }
    else if (subsCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.subcontractor?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(subsCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [subsCurrentWfTaskSelector]);

  useEffect(() => {
    if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
      setWfTask(recCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    } else if (recCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.recruiter?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(recCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadRecruiterWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [recCurrentWfTaskSelector]);

  useEffect(() => {
    console.log(candidateCurrentWfTaskSelector)
    if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
      setWfTask(candidateCurrentWfTaskSelector)
      setWfTaskReqCount(0)
    } else if (candidateCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      setWfTaskReqCount(wfTaskReqCount + 1)
      dispatch(candidateCurrentWfTaskReceived(null));
      setTimeout(() => {
        dispatch(loadCandidateWfTask(applicantObj?.id));
      }, 1000);
    }
  }, [candidateCurrentWfTaskSelector]);


  const doSubmit = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Upload this Document?",
      "warning"
    );
    if (result.isConfirmed) {
      setSubmitProcess(true);
      setTimeout(() => {
        let docType = "";
        if (uploadType) docType = uploadType;
        if (uploadDocType) docType = uploadDocType;
        if (sendType === "repository") saveRepoDocs(docType);
        if (sendType === "upload") saveLocalDocs(docType);
      }, 1000);
    }
  };

  const saveRepoDocs = async (docType) => {
    let task = { ...wfTask };
    task.performerId = currentUser.id;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.applicantId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.applicantId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.applicantId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        task.applicantId = applicantObj.applicantId;
        task.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      task.applicantId = applicantObj?.id;
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(task));
    frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);
    //frmData.append("userId", usrId);
    const updDocs = selectedRepoDocs.map((doc) => {
      const newDoc = { ...doc };
      newDoc.docType = docType;
      return newDoc;
    });
    frmData.append("doc", JSON.stringify(updDocs));
    dispatch(UploadDdrmsRepositoryDocs(frmData));
  };

  useEffect(() => {
    if (ddrmsRepoUploadStatus) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
      dispatch(ddrmsRepoDocumentUploaded({ status: false }));
    }
  }, [ddrmsRepoUploadStatus]);

  const saveLocalDocs = async (docType) => {
    const task = { ...wfTask };
    //wfTask.performerId = workItem.applicantId;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.performerId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.performerId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.performerId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        usrId = applicantObj.applicantId;
        task.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      task.performerId = applicantObj?.id;
    }

    if (docType?.includes("req_")) {
      usrId = task.performerId;
      task.performerId = parseInt(currentUser.id);
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid) {
        usrId = applicantObj.recruiter.parentid;
        task.performerId = applicantObj?.id;
      }
      if (uploadType === "Subcontractor" && applicantObj?.subcontractor?.parentid) {
        usrId = applicantObj.subcontractor.parentid;
        task.performerId = applicantObj?.id;
      }
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(task));
    frmData.append("userId", usrId);
    // localDocs.map((file, key) =>
    //   frmData.append("files[" + key + "]", file.file)
    // );
    frmData.append("files", JSON.stringify(localDocs.map((file) => ({ name: file.name, type: file.type, size: file.size }))));
    frmData.append("docType", docType);
    if (!useType) frmData.append("updType", docType);
    else frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);
    dispatch(uploadLocalDocument(frmData));

  };

  useEffect(() => {
    if (localDocUploadStatusSelector > 0) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
    }
  }, [localDocUploadStatusSelector]);

  useEffect(() => {

    const uploadAllDocuments = async () => {
      if (localDocUploadSasUrlSelector && localDocUploadSasUrlSelector?.length > 0) {
        try {
          await Promise.all(
            localDocs.map((file, key) =>
              uploadFileToBlob(
                file.file,
                localDocUploadSasUrlSelector[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );

          // Runs only after ALL uploads finish   
          console.log("All files uploaded successfully!");
          dispatch(localDocumentUploaded(null));
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };

    uploadAllDocuments();
  }, [localDocUploadSasUrlSelector]);

  const handlePwdChecked = ({ currentTarget }) => {
    if (currentTarget.checked) {
      if (uploadType === "Subcontractor") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.subcontractor.fuid;
          const pfName = applicantObj.subcontractor.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Recruiter") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.recruiter.fuid;
          const pfName = applicantObj.recruiter.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Candidate") {
        const pfId = applicantObj.performerid;
        const pfName = applicantObj.performername.substring(0, 3).toLowerCase();
        setIsPwd(pfName + pfId);
      }
    } else {
      setIsPwd("");
    }
  };

  const handleUseTypeSelect = ({ currentTarget }) => {
    if (currentTarget.checked) setUseType("internal");
    else setUseType("sharing");
  };

  const showOptions = !(
    uploadType === "msp" ||
    uploadType === "agency" ||
    uploadType === "ProjectInfo" ||
    uploadType?.includes("ach_") ||
    uploadType?.includes("insurance_") ||
    uploadDocType?.includes("req_") ||
    uploadDocType === "reporting"
  );

  const performerName = applicantObj?.performername || applicantObj?.performerName || applicantObj?.label || applicantObj?.name || "";
  const performerId = applicantObj?.performerid || applicantObj?.fuid || applicantObj?.id || "";
  const ciid = workItem?.ciid || "";

  return (
    <>
      <style>{`
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }
        .modal.fade .crd-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .crd-modal.modal-dialog {
          transform: scale(1) !important;
        }
        .crd-modal {
          max-width: 90% !important;
          width: 1200px !important;
          font-family: "Open Sans", sans-serif !important;
          color: #1e293b !important;
        }
        .crd-modal .modal-content {
          border-radius: 0 !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          max-height: calc(100vh - 60px) !important;
          height: auto !important;
          display: flex !important;
          flex-direction: column !important;
        }
        .crd-shell {
          background: #ffffff;
          display: flex;
          flex-direction: column;
          min-height: 0;
          flex: 1;
        }
        .crd-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 22px 28px 18px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
        }
        .crd-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 12px !important;
          width: 100% !important;
        }
        .crd-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 16px !important;
          width: 100% !important;
        }
        .crd-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .crd-modal .rt-header-icon {
          width: 48px !important;
          height: 48px !important;
          min-height: 48px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }
        .crd-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          min-width: 0 !important;
        }
        .crd-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
        }
        .crd-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 10px !important;
          flex-wrap: wrap !important;
        }
        .crd-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }
        .crd-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          font-size: 12px !important;
        }
        .crd-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
        }
        .crd-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 38px !important;
          height: 38px !important;
          padding: 0 !important;
          font-size: 14px !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          outline: none !important;
        }
        .crd-modal .rt-action-btn:hover {
          color: #1e293b !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
        }
        .crd-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }
        .crd-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          overflow-y: auto !important;
          display: flex !important;
          flex-direction: column !important;
          flex: 1 !important;
          min-height: 0 !important;
          max-height: calc(100vh - 180px) !important;
        }
        .crd-modal .modal-body::-webkit-scrollbar {
          width: 6px !important;
        }
        .crd-modal .modal-body::-webkit-scrollbar-track {
          background: transparent !important;
        }
        .crd-modal .modal-body::-webkit-scrollbar-thumb {
          background: #cbd5e1 !important;
          border-radius: 0 !important;
        }
        .crd-two-col {
          display: flex;
          gap: 24px;
          align-items: stretch;
          width: 100%;
          min-height: 0;
          flex: 1;
        }
        .crd-left-panel {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 16px;
          min-height: 0;
        }
        .crd-right-panel {
          width: 420px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          gap: 18px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          padding: 20px;
          box-shadow: none !important;
          text-align: left;
          min-height: 0;
        }
        @media (max-width: 992px) {
          .crd-two-col { flex-direction: column; }
          .crd-right-panel { width: 100%; }
        }
        .crd-form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
          text-align: left;
        }
        .crd-label {
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #334155 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          margin: 0 !important;
        }
        .crd-checkbox-card {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 14px;
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          background: #ffffff;
          cursor: pointer;
          transition: all 0.2s ease;
          user-select: none;
        }
        .crd-checkbox-card:hover {
          border-color: #94a3b8;
          background: #f8fafc;
        }
        .crd-checkbox-card.active {
          border-color: #171717;
          background: #f8fafc;
          box-shadow: none !important;
        }
        .crd-checkbox-indicator {
          width: 18px;
          height: 18px;
          border: 2px solid #cbd5e1;
          border-radius: 0 !important;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 2px;
        }
        .crd-checkbox-indicator::after {
          content: "";
          display: none;
          width: 5px;
          height: 9px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          margin-bottom: 2px;
        }
        .crd-checkbox-card.active .crd-checkbox-indicator {
          background-color: #171717;
          border-color: #171717;
        }
        .crd-checkbox-card.active .crd-checkbox-indicator::after {
          display: block;
        }
        .crd-checkbox-label-text {
          font-size: 13.5px;
          font-weight: 600;
          color: #1e293b;
        }
        .crd-checkbox-desc {
          font-size: 12px;
          color: #64748b;
          margin-top: 4px;
          line-height: 1.4;
        }
        .crd-textarea {
          width: 100%;
          min-height: 100px;
          padding: 10px 14px;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          background-color: #ffffff !important;
          color: #1e293b !important;
          font-size: 13.5px !important;
          font-weight: 400 !important;
          transition: all 0.15s ease;
          outline: none;
          resize: vertical;
        }
        .crd-textarea:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }
        .crd-modal .modal-footer {
          padding: 16px 24px !important;
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: flex-end !important;
          gap: 10px !important;
          flex-shrink: 0 !important;
        }
        .crd-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 7px 16px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
        }
        .crd-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #1e293b !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
        }
        .crd-modal .wf-modal-footer-close-btn:hover i {
          color: #ef4444 !important;
        }
        .crd-modal .crd-btn-submit {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          padding: 7px 18px !important;
          border-radius: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          white-space: nowrap !important;
          border: 1px solid #2563eb !important;
          background: #2563eb !important;
          color: #ffffff !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .crd-modal .crd-btn-submit:hover:not(:disabled) {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
        }
        .crd-modal .crd-btn-submit:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          opacity: 0.85 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }
      `}</style>

      <Modal
        show={docShowHide}
        size="xl"
        centered
        scrollable
        onHide={() => handleDocShowHide("")}
        dialogClassName="rt-tools-modal crd-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className={`rt-header-icon fa ${sendType === "repository" ? "fa-database" : "fa-upload"}`} aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>{sendType === "repository" ? "Upload from DDRMS Repository" : "Upload from Local Drive"}</span>
                    </span>
                  </h2>
                  <div className="rt-modal-meta-row">
                    {uploadType && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-briefcase" style={{ color: "#2563eb" }} />
                        <span>Performer: {uploadType.toUpperCase()}</span>
                      </span>
                    )}
                    {performerName && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" style={{ color: "#9333ea" }} />
                        <span>{performerName}</span>
                      </span>
                    )}
                    {performerId && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-id-badge" style={{ color: "#6366f1" }} />
                        <span>ID: {performerId}</span>
                      </span>
                    )}
                    {ciid && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-hashtag" style={{ color: "#d97706" }} />
                        <span>CIID {ciid}</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleDocShowHide("")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="crd-shell">
            {showOptions ? (
              <div className="crd-two-col">
                <div className="crd-left-panel">
                  {sendType === "repository" ? (
                    <UploadRepository
                      repoDocs={repoDocs}
                      setSelectedRepoDocs={setSelectedRepoDocs}
                      loading={repoLoading}
                    />
                  ) : (
                    <UploadLocal setLocalDocs={setLocalDocs} />
                  )}
                </div>
                <div className="crd-right-panel">
                  <label className="crd-label">Upload Settings</label>

                  <div
                    className={`crd-checkbox-card ${useType === "internal" ? "active" : ""}`}
                    onClick={() => handleUseTypeSelect({ currentTarget: { checked: useType !== "internal" } })}
                  >
                    <span className="crd-checkbox-indicator" />
                    <div style={{ flex: 1 }}>
                      <span className="crd-checkbox-label-text">For Internal Purposes Only</span>
                      <div className="crd-checkbox-desc">
                        Restrict file visibility to internal staff only. Candidates won't see this document.
                      </div>
                    </div>
                  </div>

                  <div className="crd-form-group">
                    <label htmlFor="message" className="crd-label">Notes / Description</label>
                    <textarea
                      className="crd-textarea"
                      id="message"
                      name="massage"
                      placeholder="Add file details, message guidelines, or context..."
                      onChange={({ currentTarget }) => setMessage(currentTarget.value)}
                      value={message}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {sendType === "repository" ? (
                  <UploadRepository
                    repoDocs={repoDocs}
                    setSelectedRepoDocs={setSelectedRepoDocs}
                    loading={repoLoading}
                  />
                ) : (
                  <UploadLocal setLocalDocs={setLocalDocs} />
                )}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleDocShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true" /> Close
          </button>
          <button
            type="button"
            className="crd-btn-submit"
            disabled={
              submitProcess ||
              (sendType === "repository" && selectedRepoDocs.length === 0) ||
              (sendType === "upload" && localDocs.length === 0)
            }
            onClick={doSubmit}
          >
            {submitProcess ? (
              <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
            ) : (
              <i className="fa fa-check mr-1" aria-hidden="true"></i>
            )}
            Attach
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CandidateReqDoc;
